import React from "react";
import Signin from "../pages/Signin";

const publicRoutes = [
  { path: "/login", element: <Signin /> }
];

export default publicRoutes;